import { Skeleton } from './Skeleton.component'

interface PostSkeletonProps {
    isMain?: boolean
    showActions?: boolean
}

/**
 * `isMain` takes precedence over `showActions` — the larger main-post variant does not
 * model an action-row placeholder, and no call site in the app passes both together.
 */
export function PostSkeleton({ isMain = false, showActions = false }: PostSkeletonProps) {
    if (isMain) {
        return (
            <div
                className="px-4 py-4 border-b border-border-light dark:border-border-dark"
                data-testid="post-skeleton"
                aria-hidden="true"
            >
                <div className="flex gap-3 items-start">
                    <Skeleton className="w-12 h-12 rounded-full flex-shrink-0" />
                    <div className="flex-1">
                        <Skeleton className="h-5 w-32" />
                        <Skeleton className="h-4 w-24 mt-1" />
                    </div>
                </div>
                <div className="mt-4 space-y-2">
                    <Skeleton className="h-6 w-full" />
                    <Skeleton className="h-6 w-4/5" />
                </div>
                <Skeleton className="h-4 w-40 mt-4" />
            </div>
        )
    }

    return (
        <div
            className="px-4 py-3 border-b border-border-light dark:border-border-dark"
            data-testid="post-skeleton"
            aria-hidden="true"
        >
            <div className="flex gap-3">
                <Skeleton className="w-8 h-8 rounded-full flex-shrink-0" />
                <div className="flex-1 space-y-2">
                    <div className="flex items-center gap-2">
                        <Skeleton className="h-4 w-24" />
                        <Skeleton className="h-3 w-20" />
                    </div>
                    <Skeleton className="h-4 w-full" />
                    <Skeleton className="h-4 w-3/4" />
                    {showActions && (
                        <div className="flex gap-6 pt-1" data-testid="post-skeleton-actions">
                            <Skeleton className="h-4 w-10" />
                            <Skeleton className="h-4 w-10" />
                            <Skeleton className="h-4 w-10" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
